/**
 * Washes of the semantic theme colours. The tokens are plain var()s, so
 * Tailwind can't apply an opacity modifier to them — `bg-danger/10`
 * compiles to nothing. Mixing the token with transparent keeps the wash
 * following the theme.
 */
export const TINT = {
  danger: "bg-[color:color-mix(in_srgb,var(--color-danger)_12%,transparent)]",
  warning: "bg-[color:color-mix(in_srgb,var(--color-warning)_15%,transparent)]",
  success: "bg-[color:color-mix(in_srgb,var(--color-success)_15%,transparent)]",
  dangerBorder: "border-[color:color-mix(in_srgb,var(--color-danger)_40%,transparent)]",
  warningBorder: "border-[color:color-mix(in_srgb,var(--color-warning)_45%,transparent)]",
} as const;
